import useMutate from "../../../../../hooks/useMutate";
import { createWorklog, updateWorklogDetail } from "../../../../../services/apiWorklog";

export function useCreateWorklogMutation({ cardId, boardId, onSuccess }) {
  return useMutate(
    createWorklog,
    [
      "watching",
      "mineCards",
      ["worklog", cardId],
      ["history", String(cardId)],
      ["worklogHistory"],
      ["boardWorklogs"],
      ["card", cardId],
      ["cards", boardId],
    ],
    () => {},
    () => {
      onSuccess?.();
    },
    () => {}
  );
}

export function useUpdateWorklogMutation({
  cardId,
  cardLogId,
  onSuccess,
}) {
  return useMutate(
    updateWorklogDetail,
    [
      ["worklog", cardId],
      ["history", String(cardId)],
      ["worklogHistory"],
      ["boardWorklogs"],
      ["card", cardId],
      ["worklogDetail", cardLogId],
    ],
    () => {},
    () => {
      onSuccess?.();
    },
    () => {}
  );
}
